module.exports = __webpack_public_path__ + "static/media/logo_white.8fc334e9.svg";